import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import s from './ProductDetailsSellerActions.sss';

interface Props {
  className?: string,
}

export const ProductDetailsSellerActionsSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <ul className={classNames(s.list, className)}>
      {Array(6).fill(null).map((_, i) => (
        <li
          key={i}
          className={s.item}
        >
          <Skeleton
            width='100%'
            height='40px'
          />
        </li>
      ))}
    </ul>
  );
};
